import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import {AuwSearchBox} from "EXT/auw_solr/Resources/Private/Js/AuwSearchBox";

export class AuwMobileMenu extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            unloadedClass: 'is-unloaded',
            busyClass: 'is-busy',
            failedClass: 'is-failed'
        }
        this.ajaxMobileMenuRequest = null;
        this.mobileMenu = null;
        this.mobileMenuApi = null;

    }

    __PageReady(){
        this.determineIfMobileMenuNeeded();
        this.$el.on("click",this.triggerClicked.bind(this));
    }

    determineIfMobileMenuNeeded(){
        if($(window).width()<=parseInt(this.config.isNeededAt,10)){
            this.$el.removeClass(this.config.unloadedClass);
            this.$el.addClass(this.config.busyClass);
            this.loadMobileMenu();
        }
    }

    triggerClicked(e){
        if(this.$el.hasClass(this.config.unloadedClass)){
            //menu ist noch nicht geladen worden
            e.preventDefault();
            this.$el.removeClass(this.config.unloadedClass);
            this.$el.addClass(this.config.busyClass);
            this.loadMobileMenu();
        }else if(this.$el.hasClass('is-active')){
            this.mobileMenuApi.close();
        }else if(this.$el.hasClass(this.config.busyClass)){
            e.preventDefault();
        }
    }


    loadMobileMenu(){
        this.ajaxMobileMenuRequest = $.ajax({
            type: "GET",
            url : this.config.ajaxroute,
            data: {nameSpace:'tx_auwmobilepushmenu_mobilemenu'},
        })
        .done(this.initMobileMenu.bind(this))
        .fail(this.failedMobileMenu.bind(this))
        .always((data) => { this.$el.removeClass(this.config.busyClass); });
    }


    initMobileMenu(data) {
        $('body').prepend($(data));

        this.mobileMenu = $('#mobile-menu');

        var extensions = ["pagedim-black"];
        if(this.config.openingDirection === "right"){
            extensions.push("position-right");
        }

        this.mobileMenu.mmenu({
                                  "slidingSubmenus":this.config.slidingSubmenus,
                                  "extensions": extensions
                         });
        this.mobileMenu.css("display","");
        this.mobileMenuApi = this.mobileMenu.data("mmenu");
        this.mobileMenuApi.bind( "open:start",() => {
            this.$el.addClass( "is-active" );
        });
        this.mobileMenuApi.bind( "close:start",() => {
            this.$el.removeClass( "is-active" );
        });
        new AuwSearchBox(this.mobileMenu.find(".mobilesearchbox"));


    }



    failedMobileMenu(){
        this.$el.addClass(this.config.failedClass);
    }



}